import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { State } from '../reducers'

/**
 * Fires the given callback when the profile changes
 * @param {any} callback
 */
export const useOnProfileChange = (callback: () => void) => {
    const [didMount, setDidMount] = useState(false)
    const profile = useSelector((state: State) => state.user.profile)

    useEffect(() => {
        setDidMount(true)
    })

    useEffect(() => {
        if (didMount && profile && callback) {
            callback()
        }
    }, [profile])
}
